import { React, useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";
import Images from "../../../media/images";
import { useForm } from "react-hook-form";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import ImageModal from "../../user-dashboard/received-documents/ImageModal";

const PublicDownloadUpload = () => {
  // const [staffDownloadList, setStaffDownloadList] = useState();
  const [changes, setChanges] = useState(true);
  const [ab, setAb] = useState(false);
  const { register, handleSubmit } = useForm();
  const [staffId, setStaffId] = useState([]);
  const [searchData, setSearchData] = useState([]);

  const [docsImg, setDocsImg] = useState("");

  const [imageDownloadList, setImageDownloadList] = useState([]);
  const [pdfDownloadList, setPdfDownloadList] = useState([]);

  useEffect(() => {
    api.get("/downloads/staff-documents/").then((resp) => {
      setImageDownloadList(
        resp.data.filter(
          (item) => item.file_type === "jpg" || item.file_type === "png"
        )
      );
      setPdfDownloadList(
        resp.data.filter(
          (item) => item.file_type === "docx" || item.file_type === "pdf"
        )
      );
      // setStaffDownloadList(resp.data);
    });
  }, [ab]);

  // fetch users
  useEffect(() => {
    api
      .get("/users/?user_type=ST")
      .then((response) => {
        // console.log("response", response.data);
        // setStaff(response.data);
        setSearchData(
          response.data.map(({ email: name, id }) => ({ name, id }))
        );
      })
      .catch((err) => alert("something went wrong"));
  }, []);

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("file", data.files[0]);
    formData.append("title", data.document);
    formData.append("staff", staffId);
    // dispatch(createDownload(formData));

    api
      .post("/downloads/staff-documents/", formData)
      .then((resp) => {
        toast.success("Data Registered Successfully");
        setAb(!ab);
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results)
  };

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result)
  };

  const handleOnSelect = (item) => {
    // console.log(item.id);
    setStaffId(item.id);
  };

  const handleOnFocus = () => {
    // console.log('Focused')
  };

  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
        <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
      </>
    );
  };

  const handleDelete = (id) => {
    api
      .delete(`/downloads/staff-documents/${id}/`)
      .then((response) => {
        toast.success("Documents deleted");
        setAb(!ab);
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };

  const handleStaffSearchPng = (e) => {
    // console.log("hello", e.target.value);
    api
      .get(`/downloads/staff-documents/?search=${e.target.value}`)
      .then((response) => {
        //  console.log(response.data)
        setImageDownloadList(
          response.data.filter(
            (item) => item.file_type === "jpg" || item.file_type === "png"
          )
        );
       
      })
      .catch((error) => {
        console.log(error);
      });
  };



  const handleStaffSearchPdf = (e) => {

    api
      .get(`/downloads/staff-documents/?search=${e.target.value}`)
      .then((response) => {
        //  console.log(response.data)
        setPdfDownloadList(
          response.data.filter(
            (item) => item.file_type === "docx" || item.file_type === "pdf"
          )
        );
       
      })
      .catch((error) => {
        console.log(error);
      });
  };






  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Staff Download and Upload Details
      </h1>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>
      {/* pdf and jpeg */}
      <div className="p-3 md:!p-10">
        <p className="text-primary-blue mt-5 font-bold underline">
          1. Png and jpg file
        </p>
        {/* upload */}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-wrap items-center justify-between "
        >
          {/* <div className="flex items-center gap-x-2"> */}
          <input
            type="file"
            name=""
            className="text-primary-blue w-48 file:bg-primary-red ml-3 file:rounded-lg file:text-white"
            id=""
            {...register("files", { required: true })}
          />

          <div style={{ width: 300 }}>
            <ReactSearchAutocomplete
              items={searchData}
              onSearch={handleOnSearch}
              onHover={handleOnHover}
              onSelect={handleOnSelect}
              onFocus={handleOnFocus}
              autoFocus
              placeholder="Search User... "
              formatResult={formatResult}
            />
          </div>

          <input
            placeholder="Document Name"
            type="text"
            className="my-3 rounded-lg border border-black p-3"
            {...register("document", { required: true })}
          />

          {/* <input
              placeholder="Staff id"
              type="number"
              className="my-3 rounded-lg border border-black p-3"
              {...register("staff", { required: true })}
              
            /> */}
          <input
            value="submit"
            type="submit"
            className="bg-primary-red  inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
          />
          {/* </div> */}

          <input
            placeholder="Search by name"
            onChange={(e) => handleStaffSearchPng(e)}
            type="text"
            className="my-3 content-end rounded-lg border border-black p-3"
          />
        </form>

        {/* <div className="flex flex-wrap items-center justify-between gap-0">
          <div className="">
            <input
              type="file"
              name=""
              className="text-primary-blue file:bg-primary-red ml-3 outline-none file:rounded-lg file:text-white"
              id=""
            />
            <input
              placeholder="Document Name"
              type="text"
              className="my-3 rounded-lg border border-black p-3"
            />
            <input
              placeholder="File type"
              type="text"
              className="my-3 w-[100px] rounded-lg border border-black p-3"
            />
            <button
              onClick={onSubmit}
              className="bg-primary-red ml-10 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
            >
              Submit
            </button>
          </div>
          <input
            placeholder="Search by name"
            type="text"
            className="my-3 content-end rounded-lg border border-black p-3"
          />
        </div> */}
        <div className="overflow-x-scroll">
          <table className="border-primary-blue min-w-full border text-center">
            <thead className="font-Bree bg-primary-red text-lg font-bold">
              <tr className="">
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  SN.
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Upload Date
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Document Name
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  File type
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="font-Acme">
              {imageDownloadList?.map((item, index) => {
                return (
                  <tr
                    key={index}
                    className="border-primary-blue border-2 bg-white"
                  >
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      {index + 1}
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      1/1/1/1
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      {item.title}
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      {item.file_type}
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#docsModalDemo"
                        onClick={() => {
                          setDocsImg(item.file);
                        }}
                        className="bg-primary-green rounded-full p-1 px-2 text-white"
                      >
                        View
                      </button>

                      <ImageModal docsImg={docsImg} />

                      <button
                        className="bg-primary-red rounded-full p-1 px-2 text-white"
                        onClick={() => handleDelete(item.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      {/* Word and exel */}
      <div className="p-3 md:!p-10">
        <p className="text-primary-blue mt-5 font-bold underline">
          1. pdf, word, and excel file
        </p>
        {/* upload */}
        <div className="flex flex-wrap items-center justify-between gap-0">
          {/* <form className="">
            <input
              type="file"
              name=""
              className="text-primary-blue file:bg-primary-red ml-3 outline-none file:rounded-lg file:text-white"
              id=""
            />
            <input
              placeholder="Document Name"
              type="text"
              className="my-3 rounded-lg border border-black p-3"
            />
            <input
              placeholder="File type"
              type="text"
              className="my-3 w-[100px] rounded-lg border border-black p-3"
            />
            <a
              href=""
              className="bg-primary-red ml-10 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
            >
              Submit
            </a>
          </form> */}

          <input
            placeholder="Search by name"
            type="text"
            onChange = {(e) => handleStaffSearchPdf(e)}
            className="my-3 content-end rounded-lg border border-black p-3"
          />
        </div>
        <div className="overflow-x-scroll">
          <table className="border-primary-blue min-w-full border text-center">
            <thead className="font-Bree bg-primary-red text-lg font-bold">
              <tr className="">
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  SN.
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Upload Date
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Document Name
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  File type
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="font-Acme">
              {pdfDownloadList?.map((item, i) => {
                return (
                  <tr key={i} className="border-primary-blue border-2 bg-white">
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      {i + 1}
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      1/1/1/1 (static)
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      {item.title}
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      {item.file_type}
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                      <a
                        href=""
                        className="bg-primary-green rounded-full p-1 px-2 text-white"
                      >
                        View
                      </a>

                      <button
                        className="bg-primary-red rounded-full p-1 px-2 text-white"
                        onClick={() => handleDelete(item.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PublicDownloadUpload;
